import { getIn } from '../../utils/getIn';
export const getHubspotSubAccountNumbers = getIn(['HUBSPOT_SUBACCOUNT']);
export const getConnectAccountNumbers = getIn(['CONNECT_ACCOUNT']);
export const getHubspotProvidedNumbers = getIn(['HUBSPOT_PORTAL_SUBACCOUNT']);
const getHasTwilioBasedNumbers = ({
  fromNumbers,
  isHubSpotEnabled
}) => {
  var _getHubspotSubAccount, _getHubspotSubAccount2, _getHubspotProvidedNu, _getHubspotProvidedNu2, _getConnectAccountNum, _getConnectAccountNum2;
  return isHubSpotEnabled && (((_getHubspotSubAccount = (_getHubspotSubAccount2 = getHubspotSubAccountNumbers(fromNumbers)) === null || _getHubspotSubAccount2 === void 0 ? void 0 : _getHubspotSubAccount2.length) !== null && _getHubspotSubAccount !== void 0 ? _getHubspotSubAccount : 0) > 0 || ((_getHubspotProvidedNu = (_getHubspotProvidedNu2 = getHubspotProvidedNumbers(fromNumbers)) === null || _getHubspotProvidedNu2 === void 0 ? void 0 : _getHubspotProvidedNu2.length) !== null && _getHubspotProvidedNu !== void 0 ? _getHubspotProvidedNu : 0) > 0) || ((_getConnectAccountNum = (_getConnectAccountNum2 = getConnectAccountNumbers(fromNumbers)) === null || _getConnectAccountNum2 === void 0 ? void 0 : _getConnectAccountNum2.length) !== null && _getConnectAccountNum !== void 0 ? _getConnectAccountNum : 0) > 0;
};
export const getHasMultipleProviders = ({
  installedCallingApplicationsLength,
  fromNumbers,
  isHubSpotEnabled
}) => {
  const hasTwilioBasedNumbers = getHasTwilioBasedNumbers({
    fromNumbers,
    isHubSpotEnabled
  });
  return installedCallingApplicationsLength > 1 || installedCallingApplicationsLength === 1 && hasTwilioBasedNumbers;
};